import gql from 'graphql-tag';
import { FLOATING_RATES_FRAGMENT, MANDATARY_RATE_FRAGMENT } from './fragment';

export const GET_FLOATING_RATES = gql`
  query FloatingRates {
    floatingRates {
      ...FloatingRatesInfo
      mandataryRates {
        ...MandataryRate
      }
    }
  }
  ${FLOATING_RATES_FRAGMENT}
  ${MANDATARY_RATE_FRAGMENT}
`;
